import { render, staticRenderFns } from "./radius.vue?vue&type=template&id=dd8bb16c"
import script from "./radius.vue?vue&type=script&lang=js"
export * from "./radius.vue?vue&type=script&lang=js"
import style0 from "./radius.vue?vue&type=style&index=0&id=dd8bb16c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports